import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface SignupState {
  password?: string;
  isEmailVerified?: boolean;
}

const initialState: SignupState = {
  password: undefined,
  isEmailVerified: undefined,
};

export const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setSignupPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    setIsEmailVerified: (state, action: PayloadAction<boolean>) => {
      state.isEmailVerified = action.payload;
    },
    clearIsEmailVerified: state => {
      state.isEmailVerified = undefined;
    },
    clearSignupState: state => {
      state.password = undefined;
      state.isEmailVerified = undefined;
    },
  },
});

export const {
  setSignupPassword,
  setIsEmailVerified,
  clearIsEmailVerified,
  clearSignupState,
} = signupSlice.actions;
